import React from "react";
import AddVentaForm from "./AddVentaForm";

const AddVenta = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Venta"}
        </button>
      </div>

      {show && (
        <div className="mt-2">
          <AddVentaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddVenta;